import React from 'react'

const MicrophoneIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="micGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(140, 180, 255, 1)" />
          <stop offset="100%" stopColor="rgba(100, 140, 220, 1)" />
        </linearGradient>
        <filter id="micGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Mic capsule */}
      <rect 
        x="9" 
        y="3" 
        width="6" 
        height="10" 
        rx="3"
        fill="url(#micGradient)"
        filter="url(#micGlow)"
      />
      
      {/* Mic stand curve */}
      <path 
        d="M6 11c0 3.3 2.7 6 6 6s6-2.7 6-6"
        stroke="url(#micGradient)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      
      {/* Mic stand */}
      <line 
        x1="12" 
        y1="17" 
        x2="12" 
        y2="21" 
        stroke="url(#micGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Base */}
      <line 
        x1="9" 
        y1="21" 
        x2="15" 
        y2="21" 
        stroke="url(#micGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Sound lines */}
      <line x1="11" y1="6" x2="11" y2="10" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1"/>
      <line x1="13" y1="6" x2="13" y2="10" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1"/>
    </svg>
  )
}

export default MicrophoneIcon
